export default {
  callingAPI: false,
  searching: '',
  id_alteracao: 0,
  nome_completo: '',
  nome_usuario: '',
  empresas: [],
  empresa_ativa: parseInt(localStorage.getItem('INDEXEMPRESA')),
  empresa_nome: '',
  empresa_id: '',
  email: '',
  api: '',
  api_bot: '',
  foto: '',
  logo: '',
  show_empresa: true,
  bot_ativo: undefined,
  fb_page_token: '',
  permite_impressao: null,
  permite_email: null,
  empresa_fb_id: '',
  modulos: [],
  token: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js